import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-200 ${
      isScrolled ? "bg-white shadow-md" : "bg-white/80 backdrop-blur-md border-b"
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <a href="/" className="text-xl font-semibold text-primary">
              OMN SEO Tools
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-sm hover:text-primary transition-colors">
              Startseite
            </a>
            <a href="/#tools" className="text-sm hover:text-primary transition-colors">
              Tools
            </a>
            <a href="/knowledge" className="text-sm hover:text-primary transition-colors">
              Wissensdatenbank
            </a>
            <a href="/about" className="text-sm hover:text-primary transition-colors">
              Über Uns
            </a>
            <a href="#contact" className="text-sm hover:text-primary transition-colors">
              Kontakt
            </a>
            <Button variant="default" size="sm">
              Strategiegespräch buchen
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4">
            <nav className="flex flex-col space-y-4">
              <a href="/" className="text-sm hover:text-primary transition-colors">
                Startseite
              </a>
              <a href="/#tools" className="text-sm hover:text-primary transition-colors">
                Tools
              </a>
              <a href="/knowledge" className="text-sm hover:text-primary transition-colors">
                Wissensdatenbank
              </a>
              <a href="/about" className="text-sm hover:text-primary transition-colors">
                Über Uns
              </a>
              <a href="#contact" className="text-sm hover:text-primary transition-colors">
                Kontakt
              </a>
              <Button variant="default" className="w-full">
                Strategiegespräch buchen
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};